module.exports = __webpack_public_path__ + "theme/assets/img/25730a72d4dfc06d5b71cc5d6916d694.ico";